//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import {
  prepareResponseData,
  removeParametrosNulos,
} from '../../../../../common/functions/http';

export default {
  props: {
    filtro: Object,
    mdOpenFrom: String,
    statusOpcoes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      obj: {},
    };
  },
  computed: {
  },
  components: {
    mdAutocomplete,
  },
  methods: {
    prepareResponseData,
    setMarca(hit) {
      this.filtro.idMarca = hit.id;
    },
    setTipoLinhaOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
    },
    setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
    },
    setFamilia(hit) {
      this.filtro.idFamilia = hit.id;
    },
    setProduto(hit) {
      this.filtro.idProduto = hit.id;
    },
    setCliente(hit) {
      this.filtro.idCliente = hit.id;
    },
    setTipoAcordo(hit) {
      this.filtro.idTipoAcordo = hit.id;
    },
    setSolicitante(hit) {
      this.filtro.idSolicitante = hit.id;
    },
    open() {
      this.$refs.modal.open();
      this.onOpen();
    },
    defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close() {
      this.$refs.modal.close();
      this.onClose();
    },
    filtrar() {
      const copiaFiltro = Object.assign({}, this.filtro);
      removeParametrosNulos(copiaFiltro);
      this.$emit('FILTROSDASH_FILTRAR', copiaFiltro);
      this.defaultClose();
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/FiltrosDashPagamento.vue?vue&type=script&lang=js&